import gql from 'graphql-tag';

export const getZones = gql`
  query ($application: Int) {
    getZones(application: $application, active: true) {
      zoneId
      application {
        applicationId
      }
      name
      remark
      authorizedCustomers {
        customerId
        identifier
        phone
        email
        remark
      }
      authorizedIBeacons {
        deviceId
        uuid
        major
        minor
      }
      authorizedEddystones {
        deviceId
        namespace
        instance
      }
      iBeacons {
        deviceId
        uuid
        major
        minor
      }
      eddystones {
        deviceId
        namespace
        instance
      }
      readers {
        deviceId
      }
      bluetoothHubs {
        deviceId
      }
    }
  }
`
